import type { components } from "../../../api/generated";
import type {
  NotificationMessage,
  NotificationMessagePage,
  NotificationMessageReadResult,
  NotificationMessageSummary,
} from "../types";

export type NotificationMessagePageResponseRaw =
  components["schemas"]["NotificationMessagePageSuccessResponse"];
export type NotificationMessageSummaryResponseRaw =
  components["schemas"]["NotificationMessageSummarySuccessResponse"];
export type NotificationMessageReadResponseRaw =
  components["schemas"]["NotificationMessageReadSuccessResponse"];

/** 将后端消息分页响应映射为前端领域对象。 */
export function mapNotificationMessagePage(
  raw: components["schemas"]["NotificationMessagePage"],
): NotificationMessagePage {
  return {
    items: (raw.items ?? []).map(mapNotificationMessage),
    total: raw.total,
    page: raw.page,
    pageSize: raw.page_size,
  };
}

/** 将后端消息记录映射为前端领域对象。 */
function mapNotificationMessage(
  raw: components["schemas"]["NotificationMessageItem"],
): NotificationMessage {
  return {
    id: raw.id,
    messageKind: raw.message_kind,
    title: raw.title,
    summary: raw.summary ?? null,
    content: raw.content ?? null,
    targetUrl: raw.target_url ?? null,
    actionLabel: raw.action_label ?? null,
    actorNameSnapshot: raw.actor_name_snapshot ?? null,
    occurredAt: raw.occurred_at,
    createdAt: raw.created_at,
    readAt: raw.read_at ?? null,
    closedAt: raw.closed_at ?? null,
    displayState: raw.display_state,
    isRead: raw.is_read,
    isClosed: raw.is_closed,
  };
}

/** 将后端汇总响应映射为前端领域对象。 */
export function mapNotificationMessageSummary(
  raw: components["schemas"]["NotificationMessageSummary"],
): NotificationMessageSummary {
  return {
    unreadCount: raw.unread_count,
    openActionCount: raw.open_action_count,
    unreadNoticeCount: raw.unread_notice_count,
  };
}

/** 将后端已读响应映射为前端领域对象。 */
export function mapNotificationMessageReadResult(
  raw: components["schemas"]["NotificationMessageReadResult"],
): NotificationMessageReadResult {
  return {
    messageId: raw.message_id,
    isRead: raw.is_read,
    readAt: raw.read_at,
  };
}
